import { ContractedSubscription } from '@/models/order/subscription/contracted/contracted-subscription'

export interface Label {
  frequency: string
  nextScheduledDate: string
  contractedDate: string
}

export function buildLabelFrom(s: ContractedSubscription): Label {
  const { nextScheduledDate, contractedDate } = buildDateLabel(s)

  return {
    nextScheduledDate,
    contractedDate,
    get frequency(): string {
      const frequency = s.frequency
      const unit = frequency.unit.label
      const value = frequency.value

      return `${unit}${value}回`
    },
  }
}
function buildDateLabel(s: ContractedSubscription): Pick<Label, 'nextScheduledDate' | 'contractedDate'> {
  const contractedDate = s.contractedAt.toLocaleDateString()

  if (s.isEnabled()) {
    return {
      nextScheduledDate: `${s.schedule.next.toLocaleDateString()}（予定）`,
      contractedDate,
    }
  }

  return {
    nextScheduledDate: '-',
    contractedDate: `${contractedDate}（解約済み）`,
  }
}
